import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAgent } from "@/api/agents";
import { AgentsQueryKeys, useUserManager } from "@/tanstackQuery/queries";

export const useCreateAgent = () => {
  const queryClient = useQueryClient();
  const userManager = useUserManager();
  return useMutation({
    mutationFn: createAgent,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [AgentsQueryKeys.All],
      });
      // The opening balance is paid by the creator when it holds a pool
      // (operator, credit seller), so its own balance moved too. Refetched
      // unconditionally rather than re-deriving the server's funding rule.
      userManager.invalidate();
    },
  });
};
